// extracted by mini-css-extract-plugin
export default {"button":"pToUA","button-primary":"a8q1N","button-secondary":"nrYR8","button-primary-v2":"rbFtZ","button-secondary-v2":"bbeii","button-v3":"L68WF"};